import { AppContextProviderKey, LocaleProviderKey } from '@/base/domains';
import { BrowserLocaleProvider } from '@/base/infrastructures/browser/BrowserLocaleProvider';
import { GlobalStoreAppContextProvider } from '@/base/infrastructures/vue/GlobalStoreAppContextProvider';
import { provide } from '@/utils/VueUtils';

export function components() {
  provide(AppContextProviderKey, new GlobalStoreAppContextProvider());
  provide(LocaleProviderKey, new BrowserLocaleProvider());
}
